const FullScreenLoading = () => {
  return (
    <div className="fixed inset-0 bg-white/50 flex items-center justify-center z-[205]">
      {/* Loader */}
      <div className="w-10 h-10 border-4 border border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};

export default FullScreenLoading;
